import { Monitor, Tablet, Smartphone } from 'lucide-react';

// car-builder-100-funcional, Fase 5 (restyle): mismo mecanismo de preview de
// la Fase 4 (dos caminos -- srcdoc autenticado para plantilla nativa, src
// directo a /l/{slug} para landing propia -- resuelto en CarBuilderPage.js),
// solo con el layout/paleta del mockup. SIN polling: el refresh lo dispara
// el padre (guardar/publicar/restablecer), igual que antes -- un intervalo
// fijo golpeando /car-sites/{slug}/preview (render completo + inventario en
// vivo) por cada pestaña abierta no escala a N tenants con el editor abierto.
//
// Refresh (dev-builder UI/UX): tabs de ancho con iconos lucide en vez de
// emoji, mismo set (Monitor/Tablet/Smartphone) que components/dev-builder/
// PreviewPane.js -- solo visual, mismo comportamiento/testids.

const WIDTH_TABS = [
  ['desktop', Monitor, 'Desktop'],
  ['tablet', Tablet, 'Tablet'],
  ['mobile', Smartphone, 'Móvil'],
];

const WIDTH_MAX = { desktop: 'max-w-full', tablet: 'max-w-[768px]', mobile: 'max-w-[375px]' };

export default function PreviewPane({
  slug,
  previewHtml,
  previewSrc,
  previewLoading,
  previewError,
  previewWidth,
  onWidthChange,
  publicHref,
  isPublished,
}) {
  return (
    <div className="flex-1 flex flex-col min-w-0 bg-gray-50" data-testid="car-builder-preview-pane">
      <div className="px-8 py-4 border-b border-gray-200 bg-white flex flex-wrap justify-between items-center gap-3">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Preview en Vivo</h2>
          <p className="text-sm text-gray-500">/{slug || 'slug'}{previewLoading ? ' · actualizando…' : ''}</p>
        </div>
        <div className="flex gap-2" data-testid="car-builder-preview-width-tabs">
          {WIDTH_TABS.map(([key, Icon, label]) => (
            <button
              key={key}
              type="button"
              onClick={() => onWidthChange(key)}
              className={`flex items-center gap-1.5 px-4 py-2 border rounded text-sm font-medium ${previewWidth === key ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`}
              data-testid={`car-builder-preview-width-${key}`}
            >
              <Icon className="h-4 w-4" /> {label}
            </button>
          ))}
        </div>
        {publicHref ? (
          <a
            href={publicHref}
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 bg-gray-900 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-black"
            data-testid="car-builder-open-landing-btn"
          >
            Abrir landing →
          </a>
        ) : (
          <button
            type="button"
            disabled
            title="Publica primero para tener una URL pública."
            className="px-4 py-2 bg-gray-200 text-gray-400 rounded text-xs font-bold uppercase tracking-widest cursor-not-allowed"
            data-testid="car-builder-open-landing-btn"
          >
            Abrir landing →
          </button>
        )}
      </div>

      <div className="flex-1 overflow-auto p-6">
        {!slug ? (
          <div className="h-full min-h-[600px] rounded border border-dashed border-gray-300 bg-white grid place-items-center text-center p-6" data-testid="car-builder-preview-empty">
            <p className="text-sm text-gray-400">Define un slug para habilitar la landing pública.</p>
          </div>
        ) : previewError ? (
          <div className="h-full min-h-[600px] rounded border border-dashed border-red-300 bg-white grid place-items-center text-center p-6" data-testid="car-builder-preview-error">
            <p className="text-sm text-red-600">{previewError}</p>
          </div>
        ) : (
          <div className={`mx-auto h-full transition-[max-width] duration-200 ${WIDTH_MAX[previewWidth] || WIDTH_MAX.desktop}`}>
            <iframe
              key={previewSrc || (previewHtml ? 'srcdoc' : 'empty')}
              title="Vista previa de Landing Page Builder"
              srcDoc={previewHtml || undefined}
              src={previewSrc || undefined}
              className="w-full rounded-lg border border-gray-200 bg-white shadow-sm"
              style={{ height: '70vh', minHeight: 600 }}
              data-testid="car-builder-preview-iframe"
            />
          </div>
        )}
      </div>

      <div className="px-8 py-3 text-sm text-gray-600 border-t border-gray-200 bg-white flex flex-wrap items-center gap-2">
        <span>🔗 <strong>URL Pública:</strong></span>
        {publicHref ? (
          <a href={publicHref} target="_blank" rel="noreferrer">
            <code className="bg-gray-100 px-2 py-1 rounded text-gray-800">{typeof window !== 'undefined' ? window.location.origin : ''}{publicHref}</code>
          </a>
        ) : (
          <code className="bg-gray-100 px-2 py-1 rounded text-gray-400">publica primero</code>
        )}
        <span className="mx-1 text-gray-300">|</span>
        <strong>Estado:</strong>
        <span className={isPublished ? 'text-green-600' : 'text-gray-500'}>{isPublished ? '✓ Publicado' : '⏸ Borrador'}</span>
      </div>
    </div>
  );
}
